export default __webpack_public_path__ + "static/media/044-zucchini.8b0b21bb.svg";